import React, {useEffect} from 'react';
import './App.css';
import Login from './Pages/Login';
import Register from './Pages/Register';
import HomePage from './Pages/Homepage/Homepage';
import RequireAuth from './Auth/Auth';
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Dashboard from './Pages/Dashboard';
import ForgotPassword from './Pages/ForgotPassword';
import { useThemeContext } from './Themes/ThemeContext';
import { ThemeProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import {lightTheme, darkTheme} from './Themes/Themes';
import AssessmentTaker from './Pages/AssessmentTaker';
import StudentSessionSearch from './Pages/StudentSessionSearch';

function App() {
  const { theme, getCurrentTheme, updateTheme } = useThemeContext();

  useEffect(() => {
    console.log("APP>JU")
    // Get the current theme from localStorage and update the state
    const currentTheme = getCurrentTheme();
    updateTheme(currentTheme);
  }, [updateTheme]);
  

  return (
        <ThemeProvider theme={theme && theme === "light" ? lightTheme : darkTheme}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path={'/login'} element={<Login />}/>
            <Route path={'/register'} element={<Register />} />
            <Route path={'/forgot_password'} element={<ForgotPassword />} />
            <Route path={'/assessment/:sessionId/:studentId/:assessmentId'} element={<AssessmentTaker /> } />
            <Route path={'/join'} element={<StudentSessionSearch /> } />
            <Route path={'/dashboard'} element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }/>
            
          </Routes>
        </Router>
        </ThemeProvider>
  );
}

export default App;
